import * as rdd from 'react-device-detect'

export const useDetectDevice = () => {
    const userUseDesktopBrowser = rdd.isBrowser
    const userUseMobileBrowser = rdd.isMobile

    return {
        userUseDesktopBrowser,
        userUseMobileBrowser,
    }
}
